import { Reducer } from 'redux';

import { ThunkSuccessAction, ThunkFailAction } from '~src/services/apiMiddleware';
import { SbPositionT } from '~src/shared/snackbar/SnackbarNotifications';
import { MediaTypes } from '~src/styles/media-templates';
import lStorage from '~src/services/localStorage.service';
import { LocalStorageKeys } from '~src/interfaces/localSotrage.types';

import * as types from './actionTypes';
import { NotificationI, NotificationSuspensionTypes } from './interfaces';

export interface AppState {
  mediaQuery?: MediaTypes;
  isNotNewUser: boolean;
  notifications: NotificationI[];
  settings: {
    notificationsPosition?: SbPositionT;
  };
  notificationsSuspended: NotificationSuspensionTypes;
}

export function getInitialAppState(): AppState {
  return {
    isNotNewUser: false,
    notifications: [],
    settings: {},
    notificationsSuspended: null,
  };
}

const appReducer: Reducer<AppState, ThunkSuccessAction | ThunkFailAction> = (
  state = getInitialAppState(),
  action,
): AppState => {
  switch (action.type) {
    case types.SET_MEDIA_SIZE:
      return { ...state, mediaQuery: action.payload };

    case types.SHOW_NOTIFICATION:
      return { ...state, notifications: addNotification(state, action.payload) };

    case types.REMOVE_NOTIFICATION:
      return { ...state, notifications: removeNotification(state.notifications, action.payload.id) };

    case types.NOTIFICATIONS_POSITION_UPDATED:
      return { ...state, settings: { ...state.settings, notificationsPosition: action.position } };

    case types.GET_APP_CONFIG:
      return {
        ...state,
        settings: { ...state.settings, notificationsPosition: action.payload.notificationsPosition },
        isNotNewUser: action.payload.isNotNewUser,
      };

    case types.SET_IS_NOT_NEW_USER:
      return { ...state, isNotNewUser: action.payload.isNotNewUser };

    case types.SET_NOTIFICATIONS_SUSPENDED:
      return { ...state, notificationsSuspended: action.payload.type };

    default:
      return state;
  }
};

const addNotification = (
  { notifications, settings, notificationsSuspended }: AppState,
  payload: NotificationI,
): NotificationI[] => {
  const notifClone = [...notifications];
  if (
    payload.oneTimeId &&
    lStorage.getItem(LocalStorageKeys.OneTimeNotifications, payload.id) === payload.oneTimeId
  ) {
    return notifications;
  }
  if (
    notifications.findIndex(item => item.id === payload.id) === -1 &&
    notificationsSuspended !== payload.type
  ) {
    const isPosTop = settings.notificationsPosition && settings.notificationsPosition.indexOf('top') !== -1;
    notifClone[isPosTop ? 'unshift' : 'push'](payload);
    if (payload.oneTimeId) {
      lStorage.setItem(LocalStorageKeys.OneTimeNotifications, payload.id, payload.oneTimeId);
    }
  }
  return notifClone;
};

const removeNotification = (notifications: NotificationI[], id: string): NotificationI[] => {
  const notifClone = [...notifications];
  const itemToRemove = notifications.findIndex((item) => item.id === id);
  if (itemToRemove !== -1) {
    notifClone.splice(itemToRemove, 1);
  }
  return notifClone;
};

export default appReducer;
